// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tdx-scroll-container[data-v-6cbfd806]{grid-gap:.5rem;gap:.5rem;overflow:auto}@media(min-width:992px){.tdx-scroll-container[data-v-6cbfd806]{grid-gap:1rem;gap:1rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
